import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { Router, RouterLink } from '@angular/router';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { StepBarComponent } from '../../components/step-bar/step-bar.component';
import { BraintreeWidgetComponent } from '../../components/braintree-widget/braintree-widget.component';
import { LocalCacheService } from '../../services/localCache.service';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { MomentPipe } from '../../utils/moment.pipe';
import { GlobalService } from '../../services/global.service';
import { GAService } from '../../services/ga.service';
import { IVRWidgetComponent } from '../../components/ivr-widget/ivr-widget.component';
import { BrowserOnlyDirective } from '../../directive/browser-only.directive';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-step-four',
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    CommonModule,
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule,
    RadioButtonModule,
    StepBarComponent,
    BraintreeWidgetComponent,
    IVRWidgetComponent,
    MomentPipe,
    BrowserOnlyDirective,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './step-four.component.html',
  styleUrl: './step-four.component.scss',
})
export class StepFourComponent implements OnInit, OnDestroy {
  policyDetails: any = {};
  selectedCover: any;
  quoteEnquiry: any;
  quoteDetail: any;
  activatedClub: string = '';
  isOnlinePayment = 'Yes';
  isTmmaUser: any;

  constructor(
    private localCacheService: LocalCacheService,
    private router: Router,
    private globalService: GlobalService,
    private gaService: GAService,
    private dateService: DateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  onPaymentTypeChange(type: string) {
    this.isOnlinePayment = type == 'Online' ? 'Yes' : 'No';
  }
  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!this.globalService.checkAndValidatePage(4, false)) {
      this.router.navigate(['/error']);
      return;
    }
    this.activatedClub = environment.autoClub;
    this.loadData();
    if (!this.quoteDetail) {
      this.router.navigate(['/']);
      return;
    }
    this.gaService.sendStep5Event();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  ngOnDestroy(): void {}

  loadData() {
    let r = this.localCacheService.getSessionStorage('r');
    this.isTmmaUser = r
      ? JSON.parse(this.localCacheService.getSessionStorage('r'))
      : false;
    this.quoteDetail =
      this.localCacheService.getSessionStorage('quoteDetail') || {};
    this.quoteEnquiry =
      this.localCacheService.getSessionStorage('quoteEnquiry') || {};
    this.selectedCover =
      this.localCacheService.getSessionStorage('selectedCoverDetail') || {};
    this.policyDetails = {
      quoteNumber: this.quoteDetail.quoteNumber,
      destination: this.countryNames,
      isSingleTrip: this.quoteEnquiry.isSingleTrip,
      promoCode: this.quoteDetail.promoCode,
      departDate: this.quoteDetail.fromDate,
      returnDate: this.quoteDetail.toDate,
      duration: this.calculateDaysBetweenDates(),
      ageOfTravellers: this.displayTravellersAge(),
      nameOfTravelers: this.displayTravelersName(),
      noOfDependents: this.quoteDetail.dependentsCount,
      productType: this.quoteDetail.productType,
      productAlias: this.quoteDetail.productAlias,
      totalCoverPolicy: this.quoteDetail.premiums.product,
      isCruise: this.quoteDetail.isCruise === true ? 'Yes' : 'No',
      isSki: this.quoteDetail.isSking === true ? 'Yes' : 'No',
      policyExcess: this.quoteDetail.premiums.excess,
      cruiseExpense: this.quoteDetail.premiums.cruise,
      skiExpense: this.quoteDetail.premiums.skiing,
      promoCodeDisc: this.quoteDetail.premiums.promoCodeDiscount,
      memberDisc: this.quoteDetail.premiums.membershipDiscount,
      additionalMedicalExpense: this.quoteDetail.premiums.medical,
      gst: this.quoteDetail.premiums.gst,
      stampDuty: this.quoteDetail.premiums.stampDuty,
      totalExpense: this.quoteDetail.premiums.totalCost,
      cancellationLimit: this.quoteDetail.premiums.cancellationLimit,
      defaultCancellation:
        this.quoteDetail.tripOptionsInfo.cancellationBeforeDepartCoverage,
    };
  }

  get countryNames(): string {
    return this.quoteEnquiry.travelDestination
      .map((country: any) => country.countryName)
      .join(', ');
  }

  calculateDaysBetweenDates() {
    const depDate = moment(this.quoteEnquiry.return);
    const rtnDate = moment(this.quoteEnquiry.depart);
    const days = this.dateService.diffInDaysInclusive(depDate, rtnDate);
    return days;
  }

  displayTravellersAge() {
    if (this.quoteEnquiry?.age2) {
      return this.quoteEnquiry.age1 + ',' + this.quoteEnquiry.age2;
    } else {
      return this.quoteEnquiry.age1;
    }
  }
  displayTravelersName() {
    if (this.quoteDetail?.travelers && this.quoteDetail.travelers.length > 0) {
      const travelerNames: string[] = [];
      const dependentNames: string[] = [];
      this.quoteDetail?.travelers.forEach((element: any) => {
        if (element.role === 'primary') {
          travelerNames[0] = `${element.firstName} ${element.lastName}`;
        } else if (element.role === 'secondary') {
          travelerNames[1] = `${element.firstName} ${element.lastName}`;
        } else {
          dependentNames.push(`${element.firstName} ${element.lastName}`);
        }
      });
      const names = `${travelerNames.join(', ')}\n${dependentNames.join(', ')}`;
      return names;
    }
    return '';
  }
}
